import { createAction } from '@reduxjs/toolkit';

import { AddTransactionPayload } from './types';

export const addTransaction = createAction<AddTransactionPayload>(
  'transactions/addTransaction'
);
